import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  H1,
  SubTitle,
  LeftRightContainer,
  ImageColumn,
  TextColumn,
} from "../../SharedComponents/sharedComponents";
import { CientLogo, ClientsWrapper } from "./clientsElements";

import img1 from "../../../assets/clientLogos/promasidor.png";
import img2 from "../../../assets/clientLogos/danone.png";
import img3 from "../../../assets/clientLogos/dhl.png";
import img4 from "../../../assets/clientLogos/emploitic.png";
import img5 from "../../../assets/clientLogos/frater_razes.png";
import img6 from "../../../assets/clientLogos/heetch.png";
import img7 from "../../../assets/clientLogos/lafarge.png";
import img8 from "../../../assets/clientLogos/lesaffre.png";
import img9 from "../../../assets/clientLogos/novo_nordisk.png";
import img10 from "../../../assets/clientLogos/pharmaliance.png";
import img11 from "../../../assets/clientLogos/ooredoo.png";
import img12 from "../../../assets/clientLogos/totalenergies.png";
import img13 from "../../../assets/clientLogos/ald.png";
import img14 from "../../../assets/clientLogos/allegorie.png";
import img15 from "../../../assets/clientLogos/awane.png";
import img16 from "../../../assets/clientLogos/citibank.png";
import img17 from "../../../assets/clientLogos/ey.png";
import img18 from "../../../assets/clientLogos/hyatt.png";
import img19 from "../../../assets/clientLogos/hydrapharm.png";
import img20 from "../../../assets/clientLogos/icosnet.png";
import img21 from "../../../assets/clientLogos/inphamedis.png";
import img22 from "../../../assets/clientLogos/nestle.png";
import img23 from "../../../assets/clientLogos/renault.png";
import img24 from "../../../assets/clientLogos/savola.png";
import img25 from "../../../assets/clientLogos/terraco_blue.png";
import img26 from "../../../assets/clientLogos/tm_agency.png";
import img27 from "../../../assets/clientLogos/jti.png";
import img28 from "../../../assets/clientLogos/oasis.png";
import img29 from "../../../assets/clientLogos/sophal.png";
import img30 from "../../../assets/clientLogos/csee.png";
import img31 from "../../../assets/clientLogos/interactiveo.png";
import img32 from "../../../assets/clientLogos/masterbuilders.png";
import img33 from "../../../assets/clientLogos/renauld.png";
import img34 from "../../../assets/clientLogos/sald.png";
import img35 from "../../../assets/clientLogos/sgs.png";
import img36 from "../../../assets/clientLogos/pixelinvest.png";
import img37 from "../../../assets/clientLogos/merck.png";
import img38 from "../../../assets/clientLogos/systhen.png";
import img39 from "../../../assets/clientLogos/bat.png";
import img40 from "../../../assets/clientLogos/ramy.png";
import img41 from "../../../assets/clientLogos/biomerieux.png";
import img42 from "../../../assets/clientLogos/gpa.png";
import img43 from "../../../assets/clientLogos/vecopharm.png";
import img44 from "../../../assets/clientLogos/beker.png";
import img45 from "../../../assets/clientLogos/bktelecom.png";
import img46 from "../../../assets/clientLogos/elkendi.png";
//import img47 from '../../../assets/clientLogos/hupppharma.png'
import img48 from "../../../assets/clientLogos/ifruit.png";
import img49 from "../../../assets/clientLogos/pirelations.png";
import img50 from "../../../assets/clientLogos/saidal.png";
import img51 from "../../../assets/clientLogos/smollan.png";
import img52 from "../../../assets/clientLogos/henkel.png";
import img53 from "../../../assets/clientLogos/alpharep.png";
import img54 from "../../../assets/clientLogos/cciaf.png";
import img55 from "../../../assets/clientLogos/labonedjma.png";
import img56 from "../../../assets/clientLogos/repsol.png";
import img57 from "../../../assets/clientLogos/ge.png";
import img58 from "../../../assets/clientLogos/imc.png";
import img59 from "../../../assets/clientLogos/cocacola.png";
import img60 from "../../../assets/clientLogos/lg.png";
import img61 from "../../../assets/clientLogos/drreddys.png";
import img62 from "../../../assets/clientLogos/beyn.png";
import img63 from "../../../assets/clientLogos/boehringer.png";
import img64 from "../../../assets/clientLogos/takeda.png";
import img65 from "../../../assets/clientLogos/petrofac.png";
import img66 from "../../../assets/clientLogos/amsaudit.png";
import img67 from "../../../assets/clientLogos/total_lubrifiant.png";
import img68 from "../../../assets/clientLogos/translev.png";
import img69 from "../../../assets/clientLogos/sodexo.png";
import img70 from "../../../assets/clientLogos/timac.png";
import img71 from "../../../assets/clientLogos/redsli.png";
import img72 from "../../../assets/clientLogos/pfizer.png";
import img73 from "../../../assets/clientLogos/pegaz.png";
import img74 from "../../../assets/clientLogos/pea.png";
import img75 from "../../../assets/clientLogos/oxxo.png";
import img76 from "../../../assets/clientLogos/nokia.png";
import img77 from "../../../assets/clientLogos/new_rest.png";
import img78 from "../../../assets/clientLogos/meklati.png";
import img79 from "../../../assets/clientLogos/ims.png";
import img80 from "../../../assets/clientLogos/huawei.png";
import img81 from "../../../assets/clientLogos/grant_thornton.png";
import img82 from "../../../assets/clientLogos/cmscgm.png";
import img83 from "../../../assets/clientLogos/aventure.png";
import img84 from "../../../assets/clientLogos/amgen.png";
import img85 from "../../../assets/clientLogos/abc_bank.png";
import img86 from "../../../assets/clientLogos/gig.png";
import img87 from "../../../assets/clientLogos/generic_lab.png";
import img88 from "../../../assets/clientLogos/mia.png";
import img89 from "../../../assets/clientLogos/kepler_technologies.png";
import img90 from "../../../assets/clientLogos/holcim.png";
import img91 from "../../../assets/clientLogos/airp.png";
import img92 from "../../../assets/clientLogos/bingo.png";
import img93 from "../../../assets/clientLogos/ifri.png";
import img94 from "../../../assets/clientLogos/neomedic.png";
import img95 from "../../../assets/clientLogos/setif_medic_2.png";
import img96 from "../../../assets/clientLogos/lilium_pharma.png";
import img97 from "../../../assets/clientLogos/astrazeneca.png";
import img98 from "../../../assets/clientLogos/bm_promotion.png";
import img99 from "../../../assets/clientLogos/boehringer_ingelheim.png";
import img100 from "../../../assets/clientLogos/celia.png";
import img101 from "../../../assets/clientLogos/chocodada.png";
import img102 from "../../../assets/clientLogos/eccbc.png";
import img103 from "../../../assets/clientLogos/hammer_group.png";
import img104 from "../../../assets/clientLogos/oxymor.png";
import img105 from "../../../assets/clientLogos/president.png";
import img106 from "../../../assets/clientLogos/saf_instant.png";
import img107 from "../../../assets/clientLogos/siemens_energy.png";
import img108 from "../../../assets/clientLogos/slb.png";
import img109 from "../../../assets/clientLogos/somepharm.png";
import img110 from "../../../assets/clientLogos/soprodim.png";
import img111 from "../../../assets/clientLogos/vitalcare.png";
import img112 from "../../../assets/clientLogos/abbott.png";
import img113 from "../../../assets/clientLogos/agb.png";
import img114 from "../../../assets/clientLogos/alc.png";
import img115 from "../../../assets/clientLogos/algesco.png";
import img116 from "../../../assets/clientLogos/altractors.png";
import img117 from "../../../assets/clientLogos/amir_clean.png";
import img118 from "../../../assets/clientLogos/apleiad.png";
import img119 from "../../../assets/clientLogos/arab_rochdi.png";
import img120 from "../../../assets/clientLogos/axa_assurances.png";
import img121 from "../../../assets/clientLogos/baxter.png";
import img122 from "../../../assets/clientLogos/bimbo.png";
import img123 from "../../../assets/clientLogos/biocare.png";
import img124 from "../../../assets/clientLogos/biogalenic.png";
import img125 from "../../../assets/clientLogos/biogenal_pharma.png";
import img126 from "../../../assets/clientLogos/biopharm.png";
import img127 from "../../../assets/clientLogos/blanchaud.png";
import img128 from "../../../assets/clientLogos/bomare.png";
import img129 from "../../../assets/clientLogos/canbebe.png";
import img130 from "../../../assets/clientLogos/carpe_diem_spa.png";
import img131 from "../../../assets/clientLogos/ccis.png";
import img132 from "../../../assets/clientLogos/concentrix.png";
import img133 from "../../../assets/clientLogos/consunet.png";
import img134 from "../../../assets/clientLogos/cotex.png";
import img135 from "../../../assets/clientLogos/cpcm.png";
import img136 from "../../../assets/clientLogos/cscec.png";
import img137 from "../../../assets/clientLogos/dar_dawa.png";
import img138 from "../../../assets/clientLogos/data_first.png";
import img139 from "../../../assets/clientLogos/diphaco.png";
import img140 from "../../../assets/clientLogos/draco.png";
import img141 from "../../../assets/clientLogos/easyfairs.png";
import img142 from "../../../assets/clientLogos/el_djazair_Idjar.png";
import img143 from "../../../assets/clientLogos/evexia.png";
import img144 from "../../../assets/clientLogos/faderco.png";
import img145 from "../../../assets/clientLogos/fiat.png";
import img146 from "../../../assets/clientLogos/flux_passion.png";
import img147 from "../../../assets/clientLogos/force_xpress.png";
import img148 from "../../../assets/clientLogos/gaya.png";
import img150 from "../../../assets/clientLogos/genisurv.png";
import img151 from "../../../assets/clientLogos/gh_lumiere.png";
import img152 from "../../../assets/clientLogos/giz.png";
import img153 from "../../../assets/clientLogos/go_fluent.png";
import img154 from "../../../assets/clientLogos/groupe_clinique_val.png";
import img155 from "../../../assets/clientLogos/hayat.png";
import img156 from "../../../assets/clientLogos/hikma.png";
import img157 from "../../../assets/clientLogos/hyatt_regency.png";
import img158 from "../../../assets/clientLogos/icoperdis.png";
import img159 from "../../../assets/clientLogos/ifag.png";
import img160 from "../../../assets/clientLogos/immar.png";
import img161 from "../../../assets/clientLogos/index.png";
import img162 from "../../../assets/clientLogos/insigne_conseil.png";
import img163 from "../../../assets/clientLogos/iserv.png";
import img164 from "../../../assets/clientLogos/kalos.png";
import img165 from "../../../assets/clientLogos/laboratoires_salem.png";
import img166 from "../../../assets/clientLogos/laboratoires_symbiose.png";
import img167 from "../../../assets/clientLogos/lfr.png";
import img168 from "../../../assets/clientLogos/lyn_pansements.png";
import img169 from "../../../assets/clientLogos/mad_diffusion.png";
import img170 from "../../../assets/clientLogos/marmedsa_bemarine.png";
import img171 from "../../../assets/clientLogos/merit_incentives.png";
import img172 from "../../../assets/clientLogos/moben.png";
import img173 from "../../../assets/clientLogos/molped.png";
import img174 from "../../../assets/clientLogos/nadpharmedic.png";
import img175 from "../../../assets/clientLogos/nch.png";
import img176 from "../../../assets/clientLogos/norafric.png";
import img177 from "../../../assets/clientLogos/novatel.png";
import img178 from "../../../assets/clientLogos/ogtm.png";
import img179 from "../../../assets/clientLogos/omo.png";
import img180 from "../../../assets/clientLogos/owe_agency.png";
import img181 from "../../../assets/clientLogos/pharma_beauty.png";
import img182 from "../../../assets/clientLogos/pharma_data.png";
import img183 from "../../../assets/clientLogos/pharmeminence.png";
import img184 from "../../../assets/clientLogos/pharmidal.png";
import img185 from "../../../assets/clientLogos/philip_morris_international.png";
import img186 from "../../../assets/clientLogos/pixel_data.png";
import img187 from "../../../assets/clientLogos/princesse_anne.png";
import img188 from "../../../assets/clientLogos/provivo.png";
import img189 from "../../../assets/clientLogos/rimel_santé.png";
import img190 from "../../../assets/clientLogos/samsung.png";
import img191 from "../../../assets/clientLogos/sanofi.png";
import img192 from "../../../assets/clientLogos/schneider_electric.png";
import img193 from "../../../assets/clientLogos/sci.png";
import img194 from "../../../assets/clientLogos/setram.png";
import img195 from "../../../assets/clientLogos/sga.png";
import img196 from "../../../assets/clientLogos/sgt.png";
import img197 from "../../../assets/clientLogos/smart_consulting_dz.png";
import img198 from "../../../assets/clientLogos/sofra.png";
import img199 from "../../../assets/clientLogos/stellantis.png";
import img200 from "../../../assets/clientLogos/swissport.png";
import img201 from "../../../assets/clientLogos/switchbio_laboratoire.png";
import img202 from "../../../assets/clientLogos/tango.png";
import img203 from "../../../assets/clientLogos/think_factory.png";
import img204 from "../../../assets/clientLogos/uni-form.png";
import img205 from "../../../assets/clientLogos/unilever.png";
import img206 from "../../../assets/clientLogos/veco_sante.png";
import img207 from "../../../assets/clientLogos/waficlub.png";
import img208 from "../../../assets/clientLogos/watson_distribution.png";
import img209 from "../../../assets/clientLogos/workhuman.png";





const ClientSection = () => {
  const [logo1, setLogo1] = useState(img11);
  const [logo2, setLogo2] = useState(img2);
  const [logo3, setLogo3] = useState(img3);
  const [logo4, setLogo4] = useState(img4);
  const [logo5, setLogo5] = useState(img5);
  const [logo6, setLogo6] = useState(img6);
  const [logo7, setLogo7] = useState(img7);
  const [logo8, setLogo8] = useState(img8);
  const [logo9, setLogo9] = useState(img9);
  const [logo10, setLogo10] = useState(img10);
  const [logo11, setLogo11] = useState(img1);
  const [logo12, setLogo12] = useState(img12);
  const [logo13, setLogo13] = useState(img13);
  const [logo14, setLogo14] = useState(img14);
  const [logo15, setLogo15] = useState(img15);
  const [logo16, setLogo16] = useState(img16);

  useEffect(() => {
    const functions = [
      setLogo1,
      setLogo2,
      setLogo3,
      setLogo4,
      setLogo5,
      setLogo6,
      setLogo7,
      setLogo8,
      setLogo9,
      setLogo10,
      setLogo11,
      setLogo12,
      setLogo13,
      setLogo14,
      setLogo15,
      setLogo16,
    ];

    const pics = [
      img17,
      img18,
      img19,
      img20,
      img21,
      img22,
      img23,
      img24,
      img25,
      img26,
      img27,
      img28,
      img29,
      img30,
      img31,
      img32,
      img33,
      img34,
      img35,
      img36,
      img37,
      img38,
      img39,
      img40,
      img41,
      img42,
      img43,
      img44,
      img45,
      img46,
      img48,
      img49,
      img50,
      img51,
      img52,
      img53,
      img54,
      img55,
      img56,
      img57,
      img58,
      img59,
      img60,
      img61,
      img62,
      img63,
      img64,
      img65,
      img66,
      img67,
      img68,
      img69,
      img70,
      img71,
      img72,
      img73,
      img74,
      img75,
      img76,
      img77,
      img78,
      img79,
      img80,
      img81,
      img82,
      img83,
      img84,
      img85,
      img86,
      img87,
      img88,
      img89,
      img90,
      img91,
      img92,
      img93,
      img94,
      img95,
      img96,
      img97,
      img98,
      img99,
      img100,
      img101,
      img102,
      img103,
      img104,
      img105,
      img106,
      img107,
      img108,
      img109,
      img110,
      img111,
      img112,
      img113,
      img114,
      img115,
      img116,
      img117,
      img118,
      img119,
      img120,
      img121,
      img122,
      img123,
      img124,
      img125,
      img126,
      img127,
      img128,
      img129,
      img130,
      img131,
      img132,
      img133,
      img134,
      img135,
      img136,
      img137,
      img138,
      img139,
      img140,
      img141,
      img142,
      img143,
      img144,
      img145,
      img146,
      img147,
      img148,
      img150,
      img151,
      img152,
      img153,
      img154,
      img155,
      img156,
      img157,
      img158,
      img159,
      img160,
      img161,
      img162,
      img163,
      img164,
      img165,
      img166,
      img167,
      img168,
      img169,
      img170,
      img171,
      img172,
      img173,
      img174,
      img175,
      img176,
      img177,
      img178,
      img179,
      img180,
      img181,
      img182,
      img183,
      img184,
      img185,
      img186,
      img187,
      img188,
      img189,
      img190,
      img191,
      img192,
      img193,
      img194,
      img195,
      img196,
      img197,
      img198,
      img199,
      img200,
      img201,
      img202,
      img203,
      img204,
      img205,
      img206,
      img207,
      img208,
      img209,
      img11,
      img2,
      img3,
      img4,
      img5,
      img6,
      img7,
      img8,
      img9,
      img10,
      img1,
      img12,
      img13,
      img14,
      img15,
      img16,
    ];

    let indexf = 0;
    let indexp = 0;

    const change = () => {
      functions[indexf](pics[indexp]);
      indexf = (indexf + 1) % functions.length;
      indexp = (indexp + 1) % pics.length;
    };

    const interval = setInterval(() => {
      change();
    }, 800);

    return () => clearInterval(interval);
  }, []);

  const { t } = useTranslation();

  return (
    <>
      <LeftRightContainer color="#e9f7f5">
        <TextColumn>
          <H1>{t("landingpage-client-title")}</H1>
          <SubTitle>{t("landingpage-client-subtitle")}</SubTitle>
        </TextColumn>
        <ImageColumn>
          <ClientsWrapper>
            <CientLogo img={logo1}></CientLogo>
            <CientLogo img={logo2}></CientLogo>
            <CientLogo img={logo3}></CientLogo>
            <CientLogo img={logo4}></CientLogo>
            <CientLogo img={logo5}></CientLogo>
            <CientLogo img={logo6}></CientLogo>
            <CientLogo img={logo7}></CientLogo>
            <CientLogo img={logo8}></CientLogo>
            <CientLogo img={logo9}></CientLogo>
            <CientLogo img={logo10}></CientLogo>
            <CientLogo img={logo11}></CientLogo>
            <CientLogo img={logo12}></CientLogo>
            <CientLogo img={logo13}></CientLogo>
            <CientLogo img={logo14}></CientLogo>
            <CientLogo img={logo15}></CientLogo>
            <CientLogo img={logo16}></CientLogo>
          </ClientsWrapper>
        </ImageColumn>
      </LeftRightContainer>
    </>
  );
};

export default ClientSection;
